import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { stripePromise } from '@lib/stripe';

import CheckoutForm from './CheckoutForm';
import CompletePackageCheckoutForm from './CompletePackageCheckoutForm';
import RemainingPaymentCheckoutForm from './RemainingPaymentCheckoutForm';
import styles from './PaymentModal.module.css';

import { COURSE_IDS } from '@/shared/constants';

export interface PaymentModalProps {
    isOpen: boolean;
    onClose: () => void;
    amount: number;
    courseId: string;
    courseName?: string;
    paymentType?: string;
    onSuccess?: (paymentData: any) => void;
}

const PaymentModal: React.FC<PaymentModalProps> = ({
    isOpen,
    onClose,
    amount,
    courseId,
    courseName = '',
    paymentType = 'full',
    onSuccess
}) => {
    if (!isOpen) return null;

    const handleSuccess = (paymentData: any) => {
        if (onSuccess) {
            onSuccess(paymentData);
        }
        onClose();
    };

    const handleError = (error: any) => {
        console.error('Payment error:', error);
    };

    const isCompletePackage = courseId === COURSE_IDS.COMPLETE;
    const isRemainingPayment = paymentType === 'remaining_balance';

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <button className={styles.closeButton} onClick={onClose} aria-label="Close">
                    ×
                </button>

                {!isCompletePackage && !isRemainingPayment && (
                    <div className={styles.modalHeader}>
                        <h2>Complete Your Payment</h2>
                        <p className={styles.courseName}>{courseName}</p>
                    </div>
                )}

                <Elements stripe={stripePromise}>
                    {isCompletePackage ? (
                        <CompletePackageCheckoutForm
                            courseId={courseId}
                            onSuccess={handleSuccess}
                            onError={handleError}
                            onCancel={onClose}
                        />
                    ) : isRemainingPayment ? (
                        <RemainingPaymentCheckoutForm
                            courseId={courseId}
                            courseName={courseName}
                            onSuccess={handleSuccess}
                            onError={handleError}
                            onCancel={onClose}
                        />
                    ) : (
                        <CheckoutForm
                            amount={amount}
                            courseId={courseId}
                            courseName={courseName}
                            paymentType={paymentType}
                            onSuccess={handleSuccess}
                            onError={handleError}
                            onCancel={onClose}
                        />
                    )}
                </Elements>
            </div>
        </div>
    );
};

export default PaymentModal;
